<template>
  <div>
    <ul class="results">
      <!-- <router-link v-for="(sval, skey) in results" :key="skey" :to="'/days/' + $route.params.day + '/' + sval.id"> -->
        <li v-for="(sval, skey) in results" :key="skey">
          <table>
            <tbody>
              <tr>
                <td>Day</td>
                <td>{{ sval.day.formatted }}</td>
                <td></td>
              </tr>
              <tr>
                <td>Time</td>
                <td>{{ sval.start_time }} &ndash; {{ sval.end_time }}</td>
                <td></td>
              </tr>
              <tr>
                <td>Room</td>
                <td>{{ sval.room.name }}</td>
                <td></td>
              </tr>
              <tr v-if="sval.session_group">
                <td>Group</td>
                <td>{{ sval.session_group.name }}</td>
                <td></td>
              </tr>
              <tr class="type" v-if="sval.session_type">
                <td>Type</td>
                <td>
                  <span class="type" :style="{ color: sval.session_type.value.color, background: sval.session_type.value.background }">
                    {{ sval.session_type.name }}
                  </span>
                </td>
                <td></td>
              </tr>
              <tr class="title">
                <td>
                  <router-link :to="'/days/' + sval.day_id + '/' + sval.id">
                    Session
                  </router-link>
                </td>
                <td>
                  <router-link :to="'/days/' + sval.day_id + '/' + sval.id">
                    <b><span v-html="highlight(sval)"></span></b>
                  </router-link>
                </td>
                <td>
                  <router-link :to="'/days/' + sval.day_id + '/' + sval.id">
                    <span class="arrow">
                      <font-awesome-icon :icon="['fas', 'angle-right']"/>
                    </span>
                  </router-link>
                </td>
              </tr>
            </tbody>
            <tbody v-if="sval.presentations" class="presentations">
              <tr v-for="(pval, pkey) in sval.presentations" :key="pkey" class="title">
                <td>
                  <router-link :to="'/days/' + sval.day_id + '/' + sval.id + '/' + pval.id">
                    Presentation
                  </router-link>
                </td>
                <td>
                  <router-link :to="'/days/' + sval.day_id + '/' + sval.id + '/' + pval.id">
                    <b><span v-html="highlight(pval)"></span></b>
                  </router-link>
                </td>
                <td>
                  <router-link :to="'/days/' + sval.day_id + '/' + sval.id + '/' + pval.id">
                    <span class="arrow">
                      <font-awesome-icon :icon="['fas', 'angle-right']"/>
                    </span>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </li>
      <!-- </router-link> -->
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState([
      'search',
      'results',
    ]),
  },
  methods: {
    highlight(item) {
      let text = (item.code) ? item.code + ' ' + item.title : item.title;
      const regex = new RegExp(this.search, 'gi');
      return text.replace(regex, `<span class="highlight">$&</span>`);
    }
  },
  created() {
    if(!this.results.length) this.$router.push('days');
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/colors';

.results {
  padding: 0;
  margin: 0;
  > li {
    list-style: none;
    padding: 12px 0 0 0;
    border-bottom: 1px solid #e4e4e4;
    position: relative;
    white-space: nowrap;
    > table {
      border: 0;
      border-spacing: 0;
      border-collapse: collapse;
      table-layout: fixed;
      width: 100%;
      > tbody {
        > tr {
          > td {
            padding: 2px 16px;
            &:first-child {
              width: 150px;
            }
            &:last-child {
              width: 60px;
            }
            width: 100%;
            > .type {
              display: inline-block;
              margin-left: -2px;
              padding: 3px 2px 2px 2px;
              border-radius: 3px;
            }
            > a {
              > .arrow {
                // position: absolute;
                // top: 50%;
                // transform: translateY(-13px);
                right: 16px;
                display: inline-block;
                height: 100%;
                font-size: 24px;
                opacity: .3;
                &:hover {
                  opacity: 1;
                }
              }
            }
            .highlight {
              background: yellow;
            }
          }
          &.type > td {
            padding: 0 16px;
          }
          &.title > td {
            padding-top: 10px;
            padding-bottom: 12px;
            &:last-child {
              padding: 0 16px;
            }
          }
        }
        &.presentations {
          > tr {
            border-top: 1px dashed #e4e4e4;
            > td {
              padding: 12px 16px;
            }
          }
        }
      }
    }
    > .arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-13px);
      right: 16px;
      display: inline-block;
      height: 100%;
      font-size: 24px;
      opacity: .3;
    }
  }
}
</style>
